import DVRSection from "./section";

var VODModel = DVRSection.extend({
    getEndTime: function () {
        return this.get(`duration`) - this.get(`startTimeOffset`);
    }
});

export default VODModel;
